var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStickIcSecondbg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 188,
    height: 253,
    viewBox: "0 0 188 253",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M163.682 4.66066C184.09 82.0079 206.421 230.332 132.484 204.853C40.062 173.003 86.0593 53.049 112.392 104.999C138.725 156.948 147.638 271.882 84.6656 239.248C21.6927 206.613 -3.28925 186.206 7.11995 163.931C17.5292 141.655 123.724 211.85 11.0654 248.898",
    stroke: "url(#paint0_linear_4493_1960)",
    strokeOpacity: 0.32,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4493_1960",
    x1: 178.604,
    y1: 183.786,
    x2: 46.3082,
    y2: 101.119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCFF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#79FF9F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickIcSecondbg);
export default __webpack_public_path__ + "static/media/stick-ic-secondbg.e8547792febadea1426cb5f1cb2606ba.svg";
export { ForwardRef as ReactComponent };